<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="rustJackingMaintainanceForm">
        <div class="my-section-box__headline">{{ 'common.airDiscBrake_value_calculator_drum_rust' | cxTranslate }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="drumBreakReplacementDueToRustJacking">
                  {{ 'common.airDiscBrake_value_calculator_drumbrakeReplacementDueToRustJacking' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="drumBreakReplacementDueToRustJacking"
                      (keyup)="calculateAndSetSum()" />
                      @if (form.drumBreakReplacementDueToRustJacking.invalid && (form.drumBreakReplacementDueToRustJacking.dirty || form.drumBreakReplacementDueToRustJacking.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.form_field_required'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.airdiscBrake_text_numberof_vahicles' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumbrakeReplacementDueToRustJacking',
                                   'common.airDiscBrake_value_calculator_popup_drumbrakeReplacementDueToRustJacking')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc rust maintainance Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="rustJackingShoeReplacementUnitCost">
                    {{ 'common.airDiscBrake_value_calculator_rustJackingShoeReplacementUnitCost' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="rustJackingShoeReplacementUnitCost" readonly />
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_rustJackingShoeReplacementUnitCost',
                                   'common.airDiscBrake_value_calculator_popup_rustJackingShoeReplacementUnitCost')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc rust maintainance Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row  col-12">
                <!-- As per production empty block -->
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="rustJackingShoeReplacementFleetCost">
                    {{ 'common.airDiscBrake_value_calculator_rustJackingShoeReplacementFleetCost' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="rustJackingShoeReplacementFleetCost" readonly />
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                      {{ 'common.text_smartire_usd' | cxTranslate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="airdisk-button-block">
                <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                  (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                  alt="Air Disc rust maintainance Service Back">
                {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                  (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                  <img src="/icons/link-right-white.svg" class="right-arrow"
                  alt="Air Disc rust maintainance Service Next"></button>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>